import { ActionReducerMap } from '@ngrx/store'

export interface AppState {}

export const reducers: ActionReducerMap<AppState> = {}
